import { render } from "./UndergroundToken.vue?vue&type=template&id=063c1fd3&ts=true"
import script from "./UndergroundToken.vue?vue&type=script&lang=ts"
export * from "./UndergroundToken.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__